// auth
export const GET_ERRORS = 'GET_ERRORS'
export const SET_WEBSITE_USER = 'SET_WEBSITE_USER'

//lang
export const SET_LANGUAGE = 'SET_LANGUAGE'
